<div
  class="spacing--margin-left spacing--margin-right spacing--padding-all flex--row flex--nowrap flex--justify-space-between flex--align-center border-bottom--gray4"
>
  <div class="flex--row flex--nowrap flex--align-start">
    {{ text }}
  </div>

  <div class="flex--row flex--nowrap flex--align-end">
    <div class="my-advertisements-button-container spacing--margin-right">
      <a mat-button (click)="navigateToMyAdvertisements()" target="_blank">
        {{ 'shared.advertisement-management-header.my-advertisements-button' | translate }}
      </a>
    </div>

    <div class="flex--row flex--nowrap">
      <agr-primary-action
        [actionText]="'shared.advertisement-management-header.add-offer-button' | translate"
        actionIcon="add"
        class="spacing--margin-right place-offer-button-container"
        (action)="navigateToOfferForm()"
      ></agr-primary-action>
      <div
        class="flex--nowrap flex--row flex--align-center flex--justify-center place-request-container"
        (click)="navigateToRequestForm()"
      >
        <button mat-button class="add-request-button">
          <mat-icon> add </mat-icon>
          {{ 'shared.advertisement-management-header.add-request-button' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
